import { makeUnorderedSelectors } from '@/store/repository';
import { Asset } from '@/store/types';

const selector = makeUnorderedSelectors<Asset>();

export const { get, getAll, getOrNull } = selector;
